import { type ActionFunctionArgs, Form, redirect  } from 'react-router'
import { Button } from '#app/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '#app/components/ui/card'
import { Input } from '#app/components/ui/input'
import { Label } from '#app/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '#app/components/ui/select'
import { requireUserId } from '#app/utils/auth.server'
import { prisma } from '#app/utils/db.server'

export async function action({ request }: ActionFunctionArgs) {
  const userId = await requireUserId(request)
  const formData = await request.formData()
  
  const name = formData.get('name') as string
  const propertyType = formData.get('propertyType') as string
  const budget = formData.get('budget') as string
  const squareFootage = formData.get('squareFootage') as string
  const address = formData.get('address') as string
  const city = formData.get('city') as string
  const country = formData.get('country') as string

  const project = await prisma.project.create({
    data: {
      name,
      propertyType: propertyType as any,
      budget: budget ? parseFloat(budget) : null,
      squareFootage: squareFootage ? parseInt(squareFootage) : null,
      address,
      city,
      country,
      ownerId: userId,
      stage: 'ORIENTATION',
      // Create associated building data
      buildingData: {
        create: {
          progress: 0,
          phase: 'PLANNING',
          issues: '[]'
        }
      },
      // Create team member entry for owner
      team: {
        create: {
          userId: userId,
          role: 'OWNER'
        }
      }
    }
  })

  return redirect(`/projects/${project.id}`)
}

export default function NewProjectRoute() {
  return (
    <div className="container max-w-2xl mx-auto py-8">
      <Card>
        <CardHeader>
          <CardTitle>Create New Project</CardTitle>
          <CardDescription>
            Start your renovation journey by creating a new project
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form method="post" className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="name">Project Name</Label>
              <Input
                id="name"
                name="name"
                placeholder="My Home Renovation"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="propertyType">Property Type</Label>
              <Select name="propertyType" defaultValue="HOUSE">
                <SelectTrigger>
                  <SelectValue placeholder="Select property type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="HOUSE">House</SelectItem>
                  <SelectItem value="APARTMENT">Apartment</SelectItem>
                  <SelectItem value="CONDO">Condo</SelectItem>
                  <SelectItem value="TOWNHOUSE">Townhouse</SelectItem>
                  <SelectItem value="OTHER">Other</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="budget">Budget ($)</Label>
                <Input
                  id="budget"
                  name="budget"
                  type="number"
                  placeholder="50000"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="squareFootage">Square Footage</Label>
                <Input
                  id="squareFootage"
                  name="squareFootage"
                  type="number"
                  placeholder="2000"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="address">Address</Label>
              <Input
                id="address"
                name="address"
                placeholder="123 Main St"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="city">City</Label>
                <Input
                  id="city"
                  name="city"
                  placeholder="San Francisco"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="country">Country</Label>
                <Input
                  id="country"
                  name="country"
                  placeholder="USA"
                />
              </div>
            </div>

            <Button type="submit" className="w-full">
              Create Project
            </Button>
          </Form>
        </CardContent>
      </Card>
    </div>
  )
}